<template>
  <v-textarea :label="label" v-model="value" :rules="validationRules" filled :disabled="disabled" />
</template>

<script>
import fieldMixin from '@/mixins/LeanField';

export default {
  name: 'LeanTextArea',
  mixins: [fieldMixin]
};
</script>
